/// //////////////////////////////////////////////////////////////////////////
//                                                                          //
//  本文件由WIDE自动生成框架，用来定义类似webcomponent的元素．                     //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// //////////////////////////////////////////////////////////////////////////
// Created At : 2018-12-17T11:10:53.088Z

'use strict'

// const Template = require('es6-template-strings')
window.pkgs = window.pkgs || {}
if (!window.Template) {
  window.Template = require('es6-template-strings')
}
